import { configureStore } from '@reduxjs/toolkit'
import { authSlice } from './slices/auth'
import { accountEntries } from './slices/account-entries'

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.buildRowData'],
      },
    }),
  reducer: {
    auth: authSlice.reducer,
    accountEntries: accountEntries.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch